/*!

=========================================================
* Black Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,Row,Col,
  Modal,
  UncontrolledTooltip
} from "reactstrap";

import GsuiteAuth from 'components/Auth/GsuiteAuth.jsx';
import logo from "assets/img/land_logo.png";
import Request from '../../common/Request';
import DialogBase from '../../views/Base/DialogBase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

class AppNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      modalSearch: false,
      color: "navbar-transparent",
      unread: {
        count: 0
      },
      message_view_flag: false,
    };
    this.dialogUnreadMessage = React.createRef();
  }
  fetchUnread = () => {
    Request.get('/api/customer_message/unread', {},
    res => {
      this.setState({
        "unread": res.Data
      }, () => {
        // console.log(this.state);
      });
    }, err=>{
      GsuiteAuth.logout()
    }, ()=>{}, true, false, false );
  }
  componentDidMount() {
    const DATA = localStorage.getItem("DATA") ? JSON.parse(localStorage.getItem("DATA") ): [] ;
    let view_flag = DATA.filter((d,i)=>d["page_id"] == "A3_01").length > 0 ? DATA.filter((d,i)=>d["page_id"] == "A3_01")[0]["data_view_flag"] : false;
    this.setState({
      message_view_flag: view_flag != false
    })

    window.addEventListener("resize", this.updateColor);
    if(view_flag != false){
      this.fetchUnread();
      this.unreadMessageInterval = setInterval(() => {
        this.fetchUnread();
      }, 1000 * 60 * 10);  
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateColor);
    clearInterval(this.unreadMessageInterval);
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: "bg-white"
      });
    } else {
      this.setState({
        color: "navbar-transparent"
      });
    }
  };
  // this function opens and closes the collapse on small devices
  toggleCollapse = () => {
    if (this.state.collapseOpen) {
      this.setState({
        color: "navbar-transparent"
      });
    } else {
      this.setState({
        color: "bg-white"
      });
    }
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // this function is to open the Search modal
  toggleModalSearch = () => {
    this.setState({
      modalSearch: !this.state.modalSearch
    });
  };
  handleClickUnreadMessage = () => {
    this.dialogUnreadMessage.current.show()
  }
  navigateMessageScreen = (project_natural_id) => {
    this.props.history.push('/cumessage/detail/'+project_natural_id)
  }
  render() {
    let picture = GsuiteAuth.get('picture');

    let pathname = this.props.location.pathname ? this.props.location.pathname : window.location.pathname;
    // console.log(pathname);

    return (
      <>
        <Navbar
          className={classNames("navbar-absolute", {
            [this.state.color]:
            pathname.indexOf("full-screen-map") === -1
          })}
          expand="lg"
        >
          <Container fluid>
            <div className="navbar-wrapper">
              <div className="navbar-minimize d-inline">
                <Button
                  className="minimize-sidebar btn-just-icon"
                  color="link"
                  id="tooltip209599"
                  onClick={this.props.handleMiniClick}
                >
                  <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                  <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  target="tooltip209599"
                  placement="right"
                >
                  サイドバーの開閉
                </UncontrolledTooltip>
              </div>
              <div
                className={classNames("navbar-toggle d-inline", {
                  toggled: this.props.sidebarOpened
                })}
              >
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.props.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand href="#" onClick={e => e.preventDefault()}>
                {/* {/*this.props.brandText} */}
                <img src={logo} alt="landmark-logo" />
              </NavbarBrand>
              {this.state.unread.count > 0 && this.state.message_view_flag === true && <>
                <div onClick={this.handleClickUnreadMessage} style={{textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer', fontSize: '27px', color: 'red'}}><FontAwesomeIcon icon={faEnvelope} />:{this.state.unread.count}件未読のメッセージがあります</div>
                <DialogUnreadMessage
                  ref={this.dialogUnreadMessage} 
                  default_footer={true}
                  data={this.state.unread}
                  clickCallback={(project_natural_id) => this.navigateMessageScreen(project_natural_id)}
                />
              </>}
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navigation"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            <Collapse navbar isOpen={this.state.collapseOpen}>
              <Nav className="ml-auto" navbar>
                <InputGroup className="search-bar" tag="li">
                <Button
                    color="link"
                    data-target="#searchModal"
                    data-toggle="modal"
                    id="search-button"
                  >
                    <i className="fas fa-question-circle header_icon" />
                  </Button>
                </InputGroup>
                {/* <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                  >
                    <div className="notification d-none d-lg-block d-xl-block" />
                    <i className="fas fa-bell header_icon" />
                    <p className="d-lg-none">Notifications</p>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                    <NavLink tag="li">
                      <DropdownItem className="nav-item">
                        ステータス変更<br />
                        ID:12345が承認されました<br />
                        2019-10-24
                      </DropdownItem>
                    </NavLink>
                  </DropdownMenu>
                </UncontrolledDropdown> */}
                <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                    onClick={e => e.preventDefault()}
                  >
                    <div className="photo">
                      <img alt="..." src={picture ? picture : require("assets/img/mike.jpg")} />
                    </div>
                    <b className="caret d-none d-lg-block d-xl-block" />
                    {/* <p className="d-lg-none">Log out</p> */}
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                    {/* <NavLink tag="li">
                      <DropdownItem className="nav-item">プロフィール</DropdownItem>
                    </NavLink> */}
                    <NavLink tag="li">
                      <DropdownItem className="nav-item" onClick={() => {window.open('https://admin.google.com/ac/users', '_blank')}}>設定</DropdownItem>
                    </NavLink>
                    <DropdownItem divider tag="li" />
                    <NavLink tag="li">
                      <DropdownItem className="nav-item" onClick={() => {GsuiteAuth.logout();}}>ログアウト</DropdownItem>
                    </NavLink>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <li className="separator d-lg-none" />
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </>
    );
  }
}
export class DialogUnreadMessage extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '　', // 何か入れないと右上のバツがずれるので
      values:{}
    });
  }

  handleClick = (project_natural_id) => {
    this.toggleModal();
    this.props.clickCallback(project_natural_id);
  }

  bodyContent() {
    const colStyle = {
      paddingLeft: '5px',
      paddingRight: '5px'
    };
    return (
      <>
        <div>
          <Container>
          {this.props.data.unread_projects.map((item, index) => (
            <Row noGutters>
              <Col style={colStyle} md="7" key={index} onClick={() => this.handleClick(item.project_natural_id)} style={{textDecoration: 'underline', fontWeight: 'bold', cursor: 'pointer'}}>{item.project_natural_id}案件について未読のメッセージがあります</Col>
              <Col style={colStyle} md="5">調査担当者：{item.survey_accounts}</Col>
            </Row>
          ))}
          </Container>
        </div>
      </>
    );
  }
}

export default AppNavbar;
